import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-btn-arrow",
  "use": "icon-btn-arrow-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-btn-arrow\"><style>#icon-btn-arrow .st1{fill:#fff}</style><circle cx=\"10\" cy=\"10\" r=\"10\" /><path class=\"st1\" d=\"M10.7 14.7l-1.4-1.4 3.3-3.4-3.3-3.2 1.4-1.4 4.7 4.6z\" /><path class=\"st1\" d=\"M5 9h8v2H5V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol